import { Calendar, Users, Eye, ArrowRight, UserPlus } from "lucide-react";
import { Link } from "react-router-dom";
import dateformat from "dateformat";

const CampaignCard = ({
  id,
  page_title,
  campaign_name,
  created_at,
  views,
  leads
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex justify-between items-start mb-4">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">{page_title}</h3>
          <p className="text-gray-800">{campaign_name}</p>
        </div>
        {/* <span className="px-3 py-1 bg-indigo-50 text-indigo-700 rounded-full text-sm font-medium">
          Active
        </span> */}
      </div>

      <div className="grid grid-cols-3 gap-4 mb-6 max-md:grid-cols-1">
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <Calendar size={16} />
          <span>{dateformat(created_at, "mmm dd, yyyy")}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <Eye size={16} />
          <span>{views} views</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <Users size={16} />
          <span>{leads} leads</span>
        </div>
      </div>

      <div className="flex items-center gap-4 max-md:block">
        <Link
          to={`/campaigns-list/${id}`}
          className="flex-1 inline-flex items-center justify-center gap-2 text-indigo-600 hover:text-indigo-700 font-medium border border-indigo-200 rounded-lg px-4 py-2 hover:bg-indigo-50 max-md:w-full max-md:mb-2"
        >
          <ArrowRight size={16} />
          Edit Campaign
        </Link>
        <Link
          to={`/campaigns-list/${id}/leads`}
          className="flex-1 inline-flex items-center justify-center gap-2 text-emerald-600 hover:text-emerald-700 font-medium border border-emerald-200 rounded-lg px-4 py-2 hover:bg-emerald-50 max-md:w-full"
        >
          <UserPlus size={16} />
          Leads
        </Link>
      </div>
    </div>
  );
};

export default CampaignCard;
